import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import noData from 'highcharts/modules/no-data-to-display';
import moment from 'moment';
import { LINE_STYLE } from '../../constants/CompareChartConstants';
require('highcharts/modules/annotations')(Highcharts);
noData(Highcharts);

class CompareChart extends Component {
  constructor(props) {
    super(props);
    this.chartComponent = React.createRef();
    this.state = {
      mapOptions: {
        credits: {
          enabled: false,
        },
        chart: {
          type: 'line',
          marginTop: 36,
          height: 254,
          marginBottom: 30,
          marginRight: 30,
        },
        title: {
          text: '',
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          line: {
            color: this.props.activeLabel.color,
            marker: { enabled: false },
          },
        },
        series: [],
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            day: '%e %b',
            minute: '%I:%M %P',
            hour: '%I:%M %P',
          },
          startOfWeek: 0,
          startOnTick: false,
          endOnTick: false,
          labels: {
            style: {
              color: '#999999',
              fontSize: '8px',
              lineHeight: '5px',
              textTransform: 'capitalize',
            },
          },
        },
        yAxis: {
          labels: {
            style: {
              fontSize: '8px',
            },
            y: 2,
          },
          title: {
            text: 'Number Of Comments',
            style: {
              fontSize: '8px',
            },
          },
        },
      },
    };
  }

  parseCompareChart = chart => {
    let tickInterval = [];
    Object.keys(chart).forEach(function(key, index) {
      chart[key].data.map(function(value, keys, index) {
        chart[key].data[keys][0] = moment.utc(value[0]).valueOf();
        tickInterval.push(chart[key].data[keys][1]);
        return value;
      });
      return chart[key];
    });
    return { chart, tickInterval };
  };

  getDataBaseOnActiveLabel(nextProps) {
    return nextProps.topicCompareData.map((topics, index) => {
      return {
        name: nextProps.selectedTopicsName[index],
        id: index,
        data: topics.flat().find(topic => topic.category === nextProps.activeLabel.key).data,
        dashStyle: LINE_STYLE[index].dashStyle,
        lineWidth: LINE_STYLE[index].lineWidth,
      };
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const data = this.getDataBaseOnActiveLabel(nextProps);
    this.parseCompareChart(data);
    this.setState({
      mapOptions: {
        series: JSON.parse(JSON.stringify(data)),
        plotOptions: {
          line: {
            color: nextProps.activeLabel.color,
          },
          xAxis: {
            tickInterval: nextProps.tickInterval,
          },
        },
      },
    });
  }

  renderCompareChart() {
    const { mapOptions } = this.state;
    return (
      <HighchartsReact highcharts={Highcharts} options={mapOptions} ref={this.chartComponent} />
    );
  }

  render() {
    return this.renderCompareChart();
  }
}

export default CompareChart;



// WEBPACK FOOTER //
// ./src/features/home/components/compare/chart/CompareChart.js